<script>
import {mapState} from "vuex";

export default {
  template: `
  <div class='is-flex' :class='isMovil ? "is-justify-center" : "" '>
    <button
        :disabled="createState"
        style="margin-right: 5px"
        class="button"
        :class="createState ? 'is-light':'is-dark'"
        @click="openForm(true)"
    >
      <span class="icon">
        <i class="material-icons">add_circle</i>
      </span>
      <span>Crear</span>
    </button>
    <button
        :disabled="dependenceState"
        style="margin-right: 5px"
        class="button"
        :class="dependenceState ? 'is-light':'is-dark'"
        @click="openForm(false)"
    >
      <span class="icon">
        <i class="material-icons">add_circle</i>
      </span>
      <span>Dependencias</span>
    </button>
    <button
        :disabled="!hasEmployees"
        class="button"
        :class="hasEmployees ? 'is-dark':'is-light'"
        v-tooltip="'Descargar empleados'"
        @click="downloadEmployees()"
    >
      <span class="icon">
        <i class="material-icons">download</i>
      </span>
      <span>Descargar</span>
    </button>
  </div>
  `,
  data() {
    return {};
  },
  props:{
    params: Object,
    proceso: Object,
    createState: Boolean,
    dependenceState: Boolean,
    employeesCount: Number,
  },
  computed: {
  ...mapState(["tokenUser","isMovil"]),
    hasEmployees(){
      return !!this.employeesCount
    },
  },
  methods:{
    openForm(d){
      this.$emit('switchForms', d)
    },
    downloadEmployees(){
      this.$emit('downloadEmployees')
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/components/climan/components/menuTableEmployee.vue